export default __webpack_public_path__ + "static/Radio_Mors_New_Logo_RGB_Podstawowy_pozytyw-72efe5a980220191a83bd950dcb763ae.svg";